var path = 'asset/asset-card.tpl.html';
var html = " <div flex layout=column style=margin-top:-10px> <div style=text-transform:uppercase;padding-bottom:10px>{{vm.item.type}}</div> <div class=tb-small ng-show=vm.isAssignedToCustomer()>{{'asset.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div> <div class=tb-small ng-show=vm.isPublic()>{{'asset.public' | translate}}</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/asset/asset-card.tpl.html
// module id = 1378
// module chunks = 1